const getPlanData = (data: any) => ({
  planName: data?.planData?.name || '',
  cliff: data?.planData?.cliff || 0,
  vestingPeriod: data?.planData?.vestingPeriod || 0,
  sharePrice:
    data?.customConditions?.sharePrice || data?.planData?.sharePrice || 0,
});

const getSharesData = (data: any) => ({
  sharesCountFuture: data?.sharesCount?.future || 0,
  beneficiaryUnits: (data?.vestedUnits || 0) + (data?.soldUnits || 0),
  soldUnits: data?.soldUnits || 0,
});

export const getDataFromBeneficiary = (beneficiaryData: any) => {
  const planData = getPlanData(beneficiaryData);
  const sharesData = getSharesData(beneficiaryData);

  return {
    ...planData,
    ...sharesData,
  };
};
